export default __webpack_public_path__ + "static/media/icon_star_person_white.87c959a3.svg";